import React from 'react';

const LoginScreen = ({username,setUsername,setOfp}) => {
    const checkUsername = (e) => {
        e.preventDefault()
        let username = document.querySelector('input[name=username]').value;
        if(username){
            // kontrol edilecek username
            fetch(`https://www.simbrief.com/api/xml.fetcher.php?username=${username}&json=1`)
            .then(data => data.json())
            .then(data => {
                let status = data.fetch.status;
                if(status === "Success"){
                    setUsername(username)
                    setOfp(JSON.stringify(data))
                    localStorage.setItem('username', JSON.stringify(username))
                }else{
                    setUsername('')
                }
            })
        }else{
            alert('boş bırakma')
        }
        

    }
    return (
        <div className="flex h-screen sm:h-full flex-1 items-center justify-center">
            <form onSubmit={checkUsername}>
                <input name="username" placeholder="Your simbrief username..." className="h-16 w-80 px-4 border border-bordercolor bg-black text-white"></input>
            </form>
        </div>
    )
}

export default LoginScreen
